<template>
  <div class="report-print-wrapper" :class="{ 'report-unavailable': !exportReady }">
    <!-- HEADER (não entra na impressão) -->
    <div class="header-relatorio nao-imprimir">
      <h2 class="titulo-pagina">{{ props.title }}</h2>
      <div class="botoes">
        <b-button variant="secondary" class="btn-voltar" @click="voltar">
          <i class="bi bi-arrow-left"></i> Voltar
        </b-button>
        <b-button
          :variant="isDownloading ? 'success' : 'danger'"
          class="btn-pdf"
          :disabled="isDownloading || !exportReady"
          @click="gerarPDF"
        >
          <i class="bi bi-file-earmark-pdf"></i>
          {{ isDownloading ? 'Baixando' : 'PDF' }}
        </b-button>
        <b-button
          :variant="isDownloadingXls ? 'success' : 'success'"
          class="btn-xls"
          :disabled="isDownloadingXls || !exportReady"
          @click="gerarXLS"
        >
          <i class="bi bi-file-earmark-excel"></i>
          {{ isDownloadingXls ? 'Baixando' : 'Excel' }}
        </b-button>

      </div>
    </div>

    <p v-if="!reportAllowed" class="alert alert-warning">Relatório não autorizado.</p>
    <!-- ÁREA IMPRIMÍVEL -->
    <div ref="printArea" class="print-area">
      <!-- Cabeçalho interno do relatório -->
      <div class="relatorio-header">
        <img
          v-if="logoUrl && !logoFailed"
          :src="logoUrl"
          alt="Logomarca"
          class="header-logo"
          @error="onLogoError"
          @load="onLogoLoad"
        />
        <img
          v-else-if="logoFallback"
          :src="logoFallback"
          alt="Logomarca"
          class="header-logo"
          @load="onLogoLoad"
        />
      </div>

      <!-- Título interno -->
      <h3 class="relatorio-title">{{ props.title }}</h3>

      <!-- Conteúdo dos relatórios (1 ou mais <h6> + <table>) -->
      <div class="relatorio-body">
        <component
          v-if="reportComponent"
          :is="reportComponent"
          :key="props.reportKey + JSON.stringify(props.params)"
          v-bind="props.params"
          :printMode="true"
          :printTitle="props.title"
          @export-ready="chamadasExportReady = $event"
        />
      </div>

      <!-- Rodapé com data e usuário -->
      <div class="relatorio-footer">
        <p class="text-left">
          Impresso em {{ formatarDataAtual() }}, por {{ userName }}
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { relatoriosAccess } from '@/utils/relatoriosAccess'
import { ref, getCurrentInstance, computed, watch } from 'vue'
import { useRouter } from 'vue-router'
import { BButton } from 'bootstrap-vue-next'
import { imageToPdfPng } from '@/utils/pdfImages';
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import * as XLSX from 'xlsx'
// import utils from "@/utils/globalUtils.js";


// Import de todos os componentes de relatório
import AlunosAniversariantes from '@/components/Gestao/Relatorios/Cadastrais/AlunosAniversariantes.vue'
import AlunosAtivos from '@/components/Gestao/Relatorios/Cadastrais/AlunosAtivos.vue'
import AlunosInativos from '@/components/Gestao/Relatorios/Cadastrais/AlunosInativos.vue'

import PorPeriodo from '@/components/Gestao/Relatorios/Despesas/PorPeriodo.vue'
import APagar from '@/components/Gestao/Relatorios/Despesas/APagar.vue'
import AnalisePorRefil from '@/components/Gestao/Relatorios/Despesas/AnalisePorRefil.vue'
import PagasPorVencimento from '@/components/Gestao/Relatorios/Despesas/PagasPorVencimento.vue'
import PagasPorPagamento from '@/components/Gestao/Relatorios/Despesas/PagasPorPagamento.vue'

import FechamentoDiario from '@/components/Gestao/Relatorios/Financeiros/FechamentoDiario.vue'
import ReceitasDespesas from '@/components/Gestao/Relatorios/Financeiros/ReceitasDespesas.vue'
import ProvasEscola from '@/components/Gestao/Relatorios/Financeiros/ProvasEscola.vue'
import ExtratoMensalidadesMatriculas from '@/components/Gestao/Relatorios/Financeiros/ExtratoMensalidadesMatriculas.vue'
import ConciliacaoBancaria from '@/components/Gestao/Relatorios/Financeiros/ConciliacaoBancaria.vue'
import RelatorioDre from '@/components/Gestao/Relatorios/Financeiros/RelatorioDre.vue'
import RelatorioPdr  from '@/components/Gestao/Relatorios/Financeiros/RelatorioPdr.vue'
import ReceitasPendencias from '@/components/Gestao/Relatorios/Financeiros/ReceitasPendencias.vue'

import ReceitasReceber from '@/components/Gestao/Relatorios/Receitas/ReceitasReceber.vue'
import ReceitasRecebidasRecebimento from '@/components/Gestao/Relatorios/Receitas/ReceitasRecebidasRecebimento.vue'
import ReceitasRecebidasVencimento from '@/components/Gestao/Relatorios/Receitas/ReceitasRecebidasVencimento.vue'
import ReceitasPorRefil from '@/components/Gestao/Relatorios/Receitas/ReceitasPorRefil.vue'
import ReceitasPorPeriodo from '@/components/Gestao/Relatorios/Receitas/ReceitasPorPeriodo.vue'

import AlunosQuedas from '@/components/Gestao/Relatorios/Operacionais/AlunosQuedas.vue'
import AlunosPorTurma from '@/components/Gestao/Relatorios/Operacionais/AlunosPorTurma.vue'
import ExperimentaisMatriculas from '@/components/Gestao/Relatorios/Operacionais/ExperimentaisMatriculas.vue'
import AvaliacoesAlunos from '@/components/Gestao/Relatorios/Operacionais/AvaliacoesAlunos.vue'
import ChamadasInstrutor from '@/components/Gestao/Relatorios/Operacionais/ChamadasInstrutor.vue'
import CavalosXAulas from '@/components/Gestao/Relatorios/Operacionais/CavalosXAulas.vue'
import ControleVencimentosPlanos from '@/components/Gestao/Relatorios/Operacionais/ControleVencimentosPlanos.vue'
import EstoqueProdutos from '@/components/Gestao/Relatorios/Operacionais/EstoqueProdutos.vue'
import GradeHorariaProfessor from '@/components/Gestao/Relatorios/Operacionais/GradeHorariaProfessor.vue'
import MatriculasNovasAnual from '@/components/Gestao/Relatorios/Operacionais/MatriculasNovasAnual.vue'
import ProspeccaoMatriculas from '@/components/Gestao/Relatorios/Operacionais/ProspeccaoMatriculas.vue'
import RetornosRenovacoes from '@/components/Gestao/Relatorios/Operacionais/RetornosRenovacoes.vue'
import ControleMensal from '@/components/Gestao/Relatorios/Operacionais/ControleMensal.vue'
import TabelaValoresPlanos from '@/components/Gestao/Relatorios/Operacionais/TabelaValoresPlanos.vue'



const { appContext } = getCurrentInstance()
const globalState = appContext.config.globalProperties.$globalState
const userName = globalState.userName
const logoUrl = computed(() => {
  const raw = (globalState.logoPath || '').trim();
  if (!raw) return '';
  try { return new URL(raw, window.location.origin).href; }  // força absoluta
  catch { return raw; }
});

const logoFailed   = ref(false);
const logoFallback = ref('');
function onLogoError() {
  // tenta sem query (?v=...) — evita 404 por cache/rota
  try { const u = new URL(logoUrl.value); u.search = ''; logoFallback.value = u.href; }
  catch { logoFallback.value = ''; }
  logoFailed.value = true;
}
function onLogoLoad() { logoFailed.value = false; }


// Props vindas da rota
const props = defineProps({
  title:     String,
  reportKey: String,
  params:    Object,
  subtitle:  { type: String, default: '' }
})

// Mapeamento reportKey → componente de relatório
const reportComponentsMap = {
  'alunos-aniversariantes': AlunosAniversariantes,
  'alunos-ativos': AlunosAtivos,
  'alunos-inativos': AlunosInativos,
  'despesas-por-periodo': PorPeriodo,
  'despesas-a-pagar': APagar,
  'despesas-analise-por-refil': AnalisePorRefil,
  'despesas-pagas-por-vencimento': PagasPorVencimento,
  'despesas-pagas-por-pagamento': PagasPorPagamento,
  'fechamento-diario': FechamentoDiario,
  'receitas-por-refil': ReceitasPorRefil,
  'receitas-despesas': ReceitasDespesas,
  'provas-escola': ProvasEscola,
  'receitas-receber': ReceitasReceber,
  'receitas-por-periodo': ReceitasPorPeriodo,
  'receitas-recebidas-recebimento': ReceitasRecebidasRecebimento,
  'receitas-recebidas-vencimento': ReceitasRecebidasVencimento,
  'extrato-mensalidades-matriculas': ExtratoMensalidadesMatriculas,
  'conciliacao-bancaria': ConciliacaoBancaria,
  'dre': RelatorioDre,
  'pdr': RelatorioPdr,
  'receitas-pendencias': ReceitasPendencias,
  'alunos-quedas': AlunosQuedas,
  'alunos-por-turma': AlunosPorTurma,
  'aulas-experimentais-matriculas': ExperimentaisMatriculas,
  'avaliacao-operacional': AvaliacoesAlunos,
  'cavalos-aulas': CavalosXAulas,
  'chamadas-instrutor': ChamadasInstrutor,
  'controle-vencimentos-planos': ControleVencimentosPlanos,
  'estoque-produtos': EstoqueProdutos,
  'grade-horaria-professor': GradeHorariaProfessor,
  'matriculas-novas-anual': MatriculasNovasAnual,
  'prospeccao-matriculas': ProspeccaoMatriculas,
  'retornos-renovacoes': RetornosRenovacoes,
  'controle-mensal': ControleMensal,
  'tabela-valores-planos': TabelaValoresPlanos,
}

const reportAllowed = computed(() => relatoriosAccess(globalState).permite('', props.reportKey))
const reportComponent = computed(() => reportAllowed.value ? reportComponentsMap[props.reportKey] || null : null)

const router = useRouter()
const chamadasExportReady = ref(false)
watch(() => [props.reportKey, props.params], () => { chamadasExportReady.value = false }, { flush: 'sync' })
const exportReady = computed(() => reportAllowed.value && (!['chamadas-instrutor', 'fechamento-diario'].includes(props.reportKey) || chamadasExportReady.value))
const isDownloading = ref(false)
const printArea     = ref(null)
const isDownloadingXls = ref(false)


// Função “Voltar”
function voltar() {
  router.back()
}

// Formata data atual no footer
function formatarDataAtual() {
  return new Date().toLocaleDateString('pt-BR', {
    day:   '2-digit',
    month: '2-digit',
    year:  'numeric'
  })
}

// ==============================
// Função principal: gerarPDF()
// ==============================
async function gerarPDF() {
  if (!exportReady.value) return
  isDownloading.value = true
  try {
    // 1) ORIENTAÇÃO CONDICIONAL (landscape só para “alunos-quedas”)
    const orientation = (props.reportKey === 'alunos-quedas' || props.reportKey === 'controle-vencimentos-planos') ? 'l' : 'p'
    const pdf         = new jsPDF(orientation, 'mm', 'a4')
    const marginLeft  = 15
    const marginRight  = 15
    const marginBottom = 20
    let cursorY       = 15

    // 2) DESENHAR LOGO (URL absoluta + tolerância a erro/timeout)
    if (logoUrl.value) {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.src = logoUrl.value;
      await new Promise((resolve) => {
        img.onload = resolve;
        img.onerror = resolve;     // não trava se der 404
        setTimeout(resolve, 1500); // timeout de segurança
      });
      if (img.naturalWidth && img.naturalHeight) {
        const maxW = 30;   // largura máxima em mm (ajuste se quiser)
        const maxH = 14;   // altura máxima em mm (ajuste se quiser)

        const ratio = img.naturalWidth / img.naturalHeight;

        let w = maxW;
        let h = w / ratio;

        // Se estourar a altura máxima, recalcula pela altura
        if (h > maxH) {
          h = maxH;
          w = h * ratio;
        }

        const logoPng = imageToPdfPng(img);
        if (logoPng) pdf.addImage(logoPng, 'PNG', marginLeft, cursorY, w, h);
      }
    }

    // 3) DESENHAR TÍTULO E SUBTÍTULO
    const pageWidth = pdf.internal.pageSize.getWidth()
    pdf.setFontSize(14)
    pdf.text(props.title, pageWidth / 2, cursorY + 10, { align: 'center' })
    cursorY += 16

    if (props.subtitle && props.subtitle.trim() !== '') {
      pdf.setFontSize(12)
      pdf.setFont(undefined, 'normal')
      pdf.text(props.subtitle, pageWidth / 2, cursorY, { align: 'center' })
      cursorY += 6
    }

    // 4) “Data: …” (se houver props.params.data)
    const dataSelecionada = props.params.data || ''
    if (dataSelecionada) {
      const [ano, mes, dia] = dataSelecionada.split('-')
      const dataFormatada  = `${dia}/${mes}/${ano}`
      pdf.setFontSize(12)
      pdf.setFont(undefined, 'italic')
      pdf.text(`Data: ${dataFormatada}`, pageWidth / 2, cursorY + 5, { align: 'center' })
      cursorY += 12
    } else {
      cursorY += 5
    }

    // 4b) Gráfico do relatório "matriculas-novas-anual" (vue-chartjs -> canvas -> imagem)
    if (props.reportKey === 'matriculas-novas-anual') {
      // procura o canvas dentro do relatório (MatriculasNovasAnual.vue)
      const chartCanvas = printArea.value.querySelector('.chart-container canvas')
      if (chartCanvas) {
        try {
          const imgData = chartCanvas.toDataURL('image/png')

          const pageWidth   = pdf.internal.pageSize.getWidth()
          const pageHeight  = pdf.internal.pageSize.getHeight()
          const maxWidth    = pageWidth - marginLeft - marginRight

          // mantém proporção do canvas original
          const canvasWidthPx  = chartCanvas.width || 800
          const canvasHeightPx = chartCanvas.height || 400
          const ratio          = canvasHeightPx / canvasWidthPx

          const imgWidthMm  = maxWidth
          const imgHeightMm = maxWidth * ratio

          // se não couber na página atual, abre nova
          if (cursorY + imgHeightMm > pageHeight - marginBottom) {
            pdf.addPage()
            cursorY = 15
          }

          pdf.addImage(
            imgData,
            'PNG',
            marginLeft,
            cursorY,
            imgWidthMm,
            imgHeightMm
          )
          cursorY += imgHeightMm + 8 // espaço depois do gráfico

        } catch (e) {
          console.error('Erro ao adicionar gráfico no PDF (matriculas-novas-anual):', e)
        }
      }
    }


    // 5) PERCORRE CADA <table> dentro de .relatorio-body
    const tabelas = printArea.value.querySelectorAll('.relatorio-body table')
    if (props.reportKey === 'fechamento-diario' && !tabelas.length) {
      pdf.text('Nenhum registro encontrado.', marginLeft, cursorY + 10)
    }
    for (let idx = 0; idx < tabelas.length; idx++) {
      const tabela   = tabelas[idx]
      const container = tabela.parentElement

      // Extrair subtítulo interno (h1…h6) para este bloco
      let subtituloTexto = ''
      const heading = container.querySelector('h1, h2, h3, h4, h5, h6')
      if (heading && heading.innerText.trim() !== '') {
        subtituloTexto = heading.innerText.trim()
      }

      // Manter o título e o início da tabela juntos neste relatório.
      if (subtituloTexto && props.reportKey === 'chamadas-instrutor') {
        pdf.setFontSize(10)
        pdf.setFont(undefined, 'bold')
        const linhas = pdf.splitTextToSize(subtituloTexto, pageWidth - marginLeft - marginRight)
        const altura = linhas.length * 5
        if (cursorY + altura + 25 > pdf.internal.pageSize.getHeight() - marginBottom) {
          pdf.addPage()
          cursorY = marginLeft
        }
        pdf.text(linhas, marginLeft, cursorY + 10)
        cursorY += altura + 10
      } else {
      // Se não couber subtítulo, nova página
      if (subtituloTexto && cursorY + 8 > pdf.internal.pageSize.getHeight()) {
        pdf.addPage()
        cursorY = marginLeft
      }
      if (subtituloTexto) {
        pdf.setFontSize(10)
        pdf.setFont(undefined, 'bold')
        pdf.text(subtituloTexto, marginLeft, cursorY + 10)
        cursorY += 15
      }

      }

      // Se não couber a tabela inteira, nova página
      if (cursorY + 10 > pdf.internal.pageSize.getHeight()) {
        pdf.addPage()
        cursorY = marginLeft
      }

      // === EXTRAÇÃO DE HEAD e BODY DAS LINHAS ===
      let headers = Array.from(
        tabela.querySelectorAll('thead th')
      ).map(th => th.innerText.trim())

      let bodyRows = []

      if (headers.length > 0) {
        // tabela padrão: usa thead + tbody
        bodyRows = Array.from(
          tabela.querySelectorAll('tbody tr')
        ).map(tr =>
          Array.from(tr.querySelectorAll('td')).map(td => td.innerText.trim())
        )
      } else {
        // tabela simples: sem thead, usa th/td dentro do tbody
        bodyRows = Array.from(
          tabela.querySelectorAll('tbody tr')
        ).map(tr =>
          Array.from(tr.querySelectorAll('th, td')).map(cell => cell.innerText.trim())
        )
      }

      // === CAPTURAR contactFlags PARA “alunos-quedas” ===
      let contactFlags = []
      if (props.reportKey === 'alunos-quedas') {
        const trs = tabela.querySelectorAll('tbody tr')
        contactFlags = Array.from(trs).map(tr => {
          const primeiraTd = tr.querySelector('td')
          return primeiraTd
            ? primeiraTd.getAttribute('data-contato-familia') === 'true'
            : false
        })
      }

      // === CAPTURAR matriculaFlags PARA “controle-vencimentos-planos” ===
      let matriculaFlags = []
      if (props.reportKey === 'controle-vencimentos-planos') {
        const trs = tabela.querySelectorAll('tbody tr')
        matriculaFlags = Array.from(trs).map(tr => {
          const primeiraTd = tr.querySelector('td')
          return primeiraTd
            ? primeiraTd.getAttribute('data-origem-matricula') === 'true'
            : false
        })
      }

      // === CAPTURAR estoqueCriticoFlags PARA “estoque-produtos” ===
      let estoqueCriticoFlags = []
      if (props.reportKey === 'estoque-produtos') {
        const trs = tabela.querySelectorAll('tbody tr')
        estoqueCriticoFlags = Array.from(trs).map(tr => {
          const tds = tr.querySelectorAll('td')
          const nomeTd = tds[1] // 2ª coluna: Produto
          return nomeTd
            ? nomeTd.getAttribute('data-estoque-critico') === 'true'
            : false
        })
      }

      // 6) CONSTRUIR CONFIGURAÇÃO DO autoTable SEM ‘foot’
      const config = {
        startY: cursorY,
        body: bodyRows,
        margin: { left: marginLeft, right: marginRight, bottom: marginBottom },
        styles: {
          fontSize: 7,
          cellPadding: 1,
          overflow: 'linebreak'
        },
        headStyles: {
          fillColor: [200, 200, 200],
          textColor: [50, 50, 50],
          fontSize: 7,
          fontStyle: 'bold'
        },
        theme: 'grid'
      }

      if (headers.length > 0) {
        config.head = [headers]
      }
      if (props.reportKey === 'fechamento-diario') {
        config.foot = Array.from(tabela.querySelectorAll('tfoot tr')).map(tr =>
          Array.from(tr.querySelectorAll('th, td')).map(cell => ({ content: cell.innerText.trim(), colSpan: cell.colSpan || 1 })))
        config.showFoot = 'lastPage'
      }

      // 6d) Para "grade-horaria-professor": desenhar quadro resumo ANTES da tabela
      if (props.reportKey === 'grade-horaria-professor') {
        // pega o resumo dentro do mesmo container do professor
        const resumoDiv = container.querySelector('.resumo-instrutor')
        if (resumoDiv) {
          const instrutorNome = resumoDiv.getAttribute('data-instrutor') || ''
          const totalAulas    = resumoDiv.getAttribute('data-total-aulas') || ''
          const totalAlunos   = resumoDiv.getAttribute('data-total-alunos') || ''

          const pageHeight = pdf.internal.pageSize.getHeight()

          // se estiver muito perto do final da página, pula pra próxima
          if (cursorY + 18 > pageHeight - marginBottom) {
            pdf.addPage()
            cursorY = 15
          }

          const resumoTop = cursorY + 8

          pdf.setFontSize(11)
          pdf.setFont(undefined, 'bold')
          pdf.text(`${instrutorNome}`, marginLeft, resumoTop)

          pdf.setFontSize(9)
          pdf.setFont(undefined, 'normal')
          pdf.text(
            `Aulas: ${totalAulas}  |  Alunos: ${totalAlunos}`,
            marginLeft,
            resumoTop + 5
          )

          // deixa um espaço maior entre o quadro e o cabeçalho da tabela
          cursorY = resumoTop + 9
          config.startY = cursorY
        }
      }

      // 7) SE FOR “alunos-quedas”, APLICAR columnStyles E didParseCell
      if (props.reportKey === 'alunos-quedas') {
        config.columnStyles = {
          0: { cellWidth: 40 },
          1: { cellWidth: 18 },
          2: { cellWidth: 22 },
          3: { cellWidth: 55 },
          4: { cellWidth: 20 },
          5: { cellWidth: 112 },
        }

        config.didParseCell = function (data) {
          // 1) pinta o nome do aluno (col 0) conforme contato_familia
          if (data.section === 'body' && data.column.index === 0) {
            if (contactFlags[data.row.index]) {
              data.cell.styles.textColor = [0, 128, 0]   // verde
            } else {
              data.cell.styles.textColor = [255, 0, 0]   // vermelho
            }
          }

          // 2) pinta a severidade (col 4)
          if (data.section === 'body' && data.column.index === 4) {
            const v = String(data.cell.raw || '').trim().toLowerCase()

            // estilo base
            data.cell.styles.fontStyle = 'bold'
            data.cell.styles.halign = 'center'

            if (v === 'vermelho') {
              // data.cell.styles.fillColor = [220, 53, 69]   // vermelho
              data.cell.styles.textColor = [220, 53, 69]
            } else if (v === 'amarelo') {
              // data.cell.styles.fillColor = [255, 193, 7]   // amarelo
              data.cell.styles.textColor = [255, 193, 7]
            } else if (v === 'roxo') {
              // data.cell.styles.fillColor = [106, 27, 154]  // roxo
              data.cell.styles.textColor = [106, 27, 154]
            } else if (v === 'verde') {
              // data.cell.styles.fillColor = [25, 135, 84]   // verde
              data.cell.styles.textColor = [25, 135, 84]
            } else {
              // normal / desconhecido
              // data.cell.styles.fillColor = [108, 117, 125] // cinza
              data.cell.styles.textColor = [108, 117, 125]
            }
          }
        }
      }

      // 7b) SE FOR “controle-vencimentos-planos”, pintar linhas vindas de 'matriculas'
      if (props.reportKey === 'controle-vencimentos-planos') {
        config.didParseCell = function (data) {
          if (data.section === 'body') {
            if (matriculaFlags[data.row.index]) {
              data.cell.styles.textColor = [178, 34, 34]
            }
          }
        }
      }

      // 7c) SE FOR “estoque-produtos”, pintar apenas a coluna "Produto"
      if (props.reportKey === 'estoque-produtos') {
        config.didParseCell = function (data) {
          if (data.section === 'body' && data.column.index === 1) {
            if (estoqueCriticoFlags[data.row.index]) {
              data.cell.styles.textColor = [255, 0, 0]   // vermelho
            } else {
              data.cell.styles.textColor = [0, 0, 200]   // azul
            }
          }
        }
      }

      // 8) EXECUTA o autoTable (apenas UMA vez)
      autoTable(pdf, config)
      cursorY = pdf.lastAutoTable.finalY + 3
      if (props.reportKey === 'fechamento-diario') {
        const note = container.querySelector('small')?.innerText.trim()
        if (note) {
          pdf.setFontSize(7)
          const lines = pdf.splitTextToSize(note, pageWidth - marginLeft - marginRight)
          if (cursorY + lines.length * 4 > pdf.internal.pageSize.getHeight() - marginBottom) { pdf.addPage(); cursorY = 15 }
          pdf.text(lines, marginLeft, cursorY + 4)
          cursorY += lines.length * 4 + 4
        }
      }

      // 🔹 Legendas específicas para "retornos-renovacoes"
      if (props.reportKey === 'retornos-renovacoes') {
        pdf.setFontSize(8)
        pdf.setFont(undefined, 'italic')
        pdf.setTextColor(50, 50, 50)

        if (idx === 0) {
          // Após a primeira tabela (RETORNOS)
          pdf.text(
            '*Retornos são matrículas "retomadas" após o fim da vigência do plano anterior no mês do filtro.',
            marginLeft,
            cursorY + 4
          )
          cursorY += 10
        } else if (idx === 1) {
          // Após a segunda tabela (RENOVAÇÕES)
          pdf.text(
            '** As renovações representam renovações simples e antecipadas registradas no mês do filtro.',
            marginLeft,
            cursorY + 4
          )
          cursorY += 10
        }
      }

      // 8b) Rodapé especial para "grade-horaria-professor" com resumo da grade
      if (props.reportKey === 'grade-horaria-professor') {
        const metricsDiv = printArea.value.querySelector('.grade-metrics')
        if (metricsDiv) {
          const alunosDistintos = metricsDiv.getAttribute('data-alunos-distintos') || ''
          const totalVinculos   = metricsDiv.getAttribute('data-total-vinculos') || ''
          const alunosMulti     = metricsDiv.getAttribute('data-alunos-multiturmas') || ''

          const pageHeight = pdf.internal.pageSize.getHeight()

          // Se estiver muito perto do fim da página, joga pra próxima
          if (cursorY + 10 > pageHeight - marginBottom) {
            pdf.addPage()
            cursorY = 15
          }

          pdf.setFontSize(8)
          pdf.setFont(undefined, 'italic')
          pdf.setTextColor(50, 50, 50)
          pdf.text(
            `Resumo: Alunos distintos na grade: ${alunosDistintos} | Posições de aula (vínculos): ${totalVinculos} | Alunos em mais de uma turma: ${alunosMulti}`,
            marginLeft,
            cursorY + 4
          )
          cursorY += 10
        }
      }

      // 9) CALCULAR E DESENHAR O TOTAL APENAS SE HOUVER COLUNA “Valor”
      //    Encontra índice da coluna “Valor” no cabeçalho (case-insensitive)
      const valorColIndex = headers.findIndex(hdr =>
        hdr.trim().toLowerCase() === 'valor' || hdr.trim().toLowerCase().includes('valor')
      )
      if (valorColIndex >= 0 && props.reportKey !== 'fechamento-diario') {
        // Soma somente essa coluna
        let totalValue = 0
        bodyRows.forEach(row => {
          let raw = row[valorColIndex] || '0'
          raw = raw.replace(/[^\d,.-]/g, '')           // remove símbolos
          const numeric = parseFloat(
            raw.replace(/\./g, '').replace(',', '.')
          ) || 0
          totalValue += numeric
        })
        if (totalValue > 0) {
          const textoTotal = new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL'
          }).format(totalValue)
          pdf.setFontSize(7)
          pdf.setFont(undefined, 'bold')
          pdf.text(
            `Total: ${textoTotal}`,
            marginLeft,
            cursorY + 0    // 4 mm abaixo da tabela
          )
          cursorY = cursorY + 2
        }
      }

      // 10) SE FOR “alunos-quedas”, DESENHAR LEGENDA ABAIXO DO TOTAL
      if (props.reportKey === 'alunos-quedas') {
        pdf.setFontSize(8)
        pdf.setFont(undefined, 'italic')
        pdf.setTextColor(50, 50, 50)
        pdf.text(
          '(*) O nome do Aluno em vermelho indica que a família não foi avisada.',
          marginLeft,
          cursorY + 4
        )
        cursorY = cursorY + 10
      }

      // 10b) Legenda para “controle-vencimentos-planos” (apenas após a ÚLTIMA tabela)
      if (props.reportKey === 'controle-vencimentos-planos' && idx === tabelas.length - 1) {
        pdf.setFontSize(8)
        pdf.setFont(undefined, 'italic')
        pdf.setTextColor(50, 50, 50)
        pdf.text(
          '(*) Linhas em vermelho indicam matrículas que ainda não foram renovadas.',
          marginLeft,
          cursorY + 4
        )
        cursorY = cursorY + 10
      }

      // 10c) Legenda para “estoque-produtos”
      if (props.reportKey === 'estoque-produtos') {
        pdf.setFontSize(8)
        pdf.setFont(undefined, 'italic')
        pdf.setTextColor(50, 50, 50)
        pdf.text(
          '(*) Nome do produto em vermelho indica estoque abaixo do mínimo.',
          marginLeft,
          cursorY + 4
        )
        cursorY = cursorY + 10
      }

    } // fim do loop pelas tabelas

    if (props.reportKey === 'controle-mensal') {
      const chartCanvases = printArea.value.querySelectorAll('.chart-container canvas')
      const pageWidth = pdf.internal.pageSize.getWidth()
      const pageHeight = pdf.internal.pageSize.getHeight()
      const maxWidth = pageWidth - marginLeft - marginRight

      // sempre começa os gráficos em nova página
      pdf.addPage()
      cursorY = 15

      chartCanvases.forEach((canvas) => {
        try {
          const imgData = canvas.toDataURL('image/png')
          const canvasWidthPx = canvas.width || 800
          const canvasHeightPx = canvas.height || 400
          const ratio = canvasHeightPx / canvasWidthPx

          const imgWidthMm = maxWidth
          const imgHeightMm = maxWidth * ratio

          if (cursorY + imgHeightMm > pageHeight - marginBottom) {
            pdf.addPage()
            cursorY = 15
          }

          pdf.addImage(
            imgData,
            'PNG',
            marginLeft,
            cursorY,
            imgWidthMm,
            imgHeightMm
          )
          cursorY += imgHeightMm + 8
        } catch (e) {
          console.error('Erro ao adicionar gráfico no PDF (controle-mensal):', e)
        }
      })

      pdf.setFontSize(8)
      pdf.setFont(undefined, 'italic')
      pdf.setTextColor(50, 50, 50)

      const linhas = [
        'Gráfico 1: composição da base operacional no período apurado, separando alunos da base, retornos e novas matrículas.',
        'Gráfico 2: distribuição dos movimentos operacionais do período: novas matrículas, retornos, renovações registradas e cancelamentos.',
        'Gráfico 3: matrículas com previsão de encerramento no período em comparação com as renovações registradas no período.'
      ]

      linhas.forEach((linha) => {
        if (cursorY + 6 > pageHeight - marginBottom) {
          pdf.addPage()
          cursorY = 15
          pdf.setFontSize(8)
          pdf.setFont(undefined, 'italic')
          pdf.setTextColor(50, 50, 50)
        }

        pdf.text(linha, marginLeft, cursorY + 4)
        cursorY += 6
      })

      cursorY += 4
    }    

    // 11) RODAPÉ EM TODAS AS PÁGINAS
    const pageCount   = pdf.getNumberOfPages()
    const pageHeight  = pdf.internal.pageSize.getHeight()
    const pageWidth2  = pdf.internal.pageSize.getWidth()
    // const marginRight = 15

    pdf.setFontSize(7)
    pdf.setFont(undefined, 'italic')
    for (let i = 1; i <= pageCount; i++) {
      pdf.setPage(i)
      const footerY = pageHeight - marginBottom / 2
      pdf.text(
        `Impresso em ${formatarDataAtual()}, por ${userName}`,
        marginLeft,
        footerY
      )
      pdf.text(
        `Página ${i} de ${pageCount}`,
        pageWidth2 - marginRight,
        footerY,
        { align: 'right' }
      )
    }

    
    // 12) SALVAR O PDF
    if (!exportReady.value) return
    pdf.save(`${props.title}.pdf`)
  } catch (err) {
    console.error('Erro ao gerar PDF com autoTable:', err)
  } finally {
    isDownloading.value = false
  }
}

/**
 * Lê todas as <table> dentro de .relatorio-body e devolve
 * um array de objetos { titulo, headers, rows }.
 * - Faz coercion de números na coluna "Valor"
 * - Tenta converter datas no padrão dd/mm/aaaa em Date
 */
function coletarTabelasDaPagina() {
  const result = []
  if (!printArea.value) return result

  const body = printArea.value.querySelector('.relatorio-body')
  if (!body) return result

  const tables = body.querySelectorAll('table')
  tables.forEach((table, idx) => {
    // Título do bloco (pega h1..h6 próximo da tabela)
    let titulo = `Tabela ${idx + 1}`
    const heading = table.parentElement?.querySelector('h1,h2,h3,h4,h5,h6')
    if (heading && heading.innerText.trim()) {
      titulo = heading.innerText.trim()
    }

    let headers = Array.from(table.querySelectorAll('thead th')).map(th =>
      th.innerText.trim()
    )

    let bodyRows = []

    if (headers.length > 0) {
      bodyRows = Array.from(table.querySelectorAll('tbody tr')).map(tr =>
        Array.from(tr.querySelectorAll('td')).map(td => td.innerText.trim())
      )
    } else {
      bodyRows = Array.from(table.querySelectorAll('tbody tr')).map(tr =>
        Array.from(tr.querySelectorAll('th, td')).map(cell => cell.innerText.trim())
      )
    }

    // Coerções leves: "Valor" -> number, datas dd/mm/aaaa -> Date
    const valorIdx = headers.findIndex(h =>
      h.toLowerCase().includes('valor')
    )
    const vencIdx = headers.findIndex(h =>
      h.toLowerCase().includes('vencimento')
    )

    const rows = bodyRows.map(cols => {
      const out = [...cols]
      if (valorIdx >= 0 && out[valorIdx]) {
        const raw = out[valorIdx]
          .replace(/[^\d,.-]/g, '')            // remove símbolos
          .replace(/\./g, '')                  // milhar
          .replace(',', '.')                   // decimal
        const num = parseFloat(raw)
        if (!isNaN(num)) out[valorIdx] = num
      }
      if (vencIdx >= 0 && out[vencIdx]) {
        // tenta dd/mm/aaaa
        const m = out[vencIdx].match(/^(\d{2})\/(\d{2})\/(\d{4})$/)
        if (m) {
          const d = new Date(+m[3], +m[2]-1, +m[1])
          if (!isNaN(d.getTime())) out[vencIdx] = d
        }
      }
      return out
    })

    if (props.reportKey === 'fechamento-diario') {
      for (const tr of table.querySelectorAll('tfoot tr')) {
        const cells = Array.from(tr.querySelectorAll('th, td')).map(cell => cell.innerText.trim()).filter(Boolean)
        const total = Array(headers.length).fill('')
        total[0] = cells[0] || 'Total'
        if (valorIdx >= 0 && cells[1]) total[valorIdx] = Number(cells[1].replace(/[^\d,.-]/g, '').replace(/\./g, '').replace(',', '.'))
        rows.push(total)
      }
      const note = table.parentElement?.querySelector('small')?.innerText.trim()
      if (note) rows.push([note])
    }
    result.push({ titulo, headers, rows })
  })

  return result
}

function sanitizeSheetName(s, fallback = 'Dados') {
  let name = String(s || '')
    .normalize('NFD')                      // separa acentos
    .replace(/[\u0300-\u036f]/g, '')      // remove acentos
    .replace(/[^A-Za-z0-9 _-]+/g, ' ')    // mantém só permitidos
    .replace(/\s{2,}/g, ' ')              // compacta espaços
    .trim();
  if (!name) name = fallback;
  if (name.length > 31) name = name.slice(0, 31);
  return name;
}

function makeUniqueSheetName(baseName, used) {
  const base = baseName || 'Dados';
  let name = base;

  if (!used.has(name)) {
    used.add(name);
    return name;
  }

  // tenta sufixos (2)...(9999)
  for (let n = 2; n < 10000; n++) {
    const suffix = ` (${n})`;
    const maxBase = 31 - suffix.length;            // 31 é o limite do Excel
    const candidate = `${base.slice(0, maxBase).trim()}${suffix}`;
    if (!used.has(candidate)) {
      used.add(candidate);
      return candidate;
    }
  }

  // Fallback extremo: timestamp (ainda respeitando 31 chars)
  const ts = `_${Date.now()}`;
  const maxBase = 31 - ts.length;
  name = `${base.slice(0, maxBase).trim()}${ts}`.slice(0, 31);
  used.add(name);
  return name;
}

async function gerarXLS() {
  if (!exportReady.value) return
  isDownloadingXls.value = true
  try {
    const wb = XLSX.utils.book_new()

    // Aba inicial “_Resumo” com metadados (opcional)
    const resumo = [
      ['Relatório', props.title || ''],
      ['Subtítulo', (props.subtitle || '').toString()],
      ['Gerado em', formatarDataAtual()],
      ['Usuário', userName || ''],
    ]
    const wsResumo = XLSX.utils.aoa_to_sheet(resumo)
    XLSX.utils.book_append_sheet(wb, wsResumo, '_Resumo')

    // Para cada tabela renderizada, cria uma aba
    const tabelas = coletarTabelasDaPagina()
    if (!tabelas.length) {
      // Se não houver tabela (caso raro), cria uma aba vazia
      const ws = XLSX.utils.aoa_to_sheet([[props.reportKey === 'fechamento-diario' ? 'Nenhum registro encontrado.' : 'Sem dados']])
      XLSX.utils.book_append_sheet(wb, ws, 'Dados')
    } else {
      const usedNames = new Set();
      tabelas.forEach((t, i) => {
        const data = props.reportKey === 'chamadas-instrutor'
          ? [[t.titulo], t.headers, ...t.rows]
          : [t.headers, ...t.rows]
        const ws = XLSX.utils.aoa_to_sheet(data)

        // Ajusta largura básica das colunas
        ws['!cols'] = t.headers.map((h, idx) => {
          const base = Math.max(
            h.length,
            ...t.rows.map(r => (r[idx] != null ? String(r[idx]).length : 0))
          )
          return { wch: Math.min(Math.max(base + 2, 10), props.reportKey === 'chamadas-instrutor' ? 200 : 40) }
        })

// nome seguro da aba + único
        let base = sanitizeSheetName(t.titulo || `Tabela_${i + 1}`, `Tabela_${i + 1}`);
        let sheetName = makeUniqueSheetName(base, usedNames);
        if (!sheetName) sheetName = `Tabela_${i + 1}`
        if (sheetName.length > 31) sheetName = sheetName.slice(0, 31)
        XLSX.utils.book_append_sheet(wb, ws, sheetName)
      })
    }

    // Salva em .xls (se preferir .xlsx, troque o bookType e a extensão)
    const fileName = `${(props.title || 'Relatório').replace(/\s+/g, '_')}.xls`
    if (!exportReady.value) return
    XLSX.writeFile(wb, fileName, { bookType: 'xls' })
  } catch (err) {
    console.error('Erro ao gerar Excel:', err)
  } finally {
    isDownloadingXls.value = false
  }
}


/**
 * Função que localiza, na última <table> renderizada,
 * o valor dentro do <tfoot> que começa com "R$" e retorna
 * algo como "Total: R$ 22.829,52". Se não encontrar, devolve “Total:”.
 */

</script>

<style scoped>
.report-print-wrapper {
  background: #f9f9f9;
}

/* HEADER (não-imprimir) */
.header-relatorio {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 20px;
  border-bottom: 1px solid #ddd;
  margin-bottom: 20px;
}
.titulo-pagina {
  font-size: 20px;
  font-weight: bold;
  color: #444;
}
.botoes {
  display: flex;
  align-items: center;
  gap: 12px;
}
.btn-voltar,
.btn-pdf,
.btn-xls {
  font-size: 12px;
  padding: 4px 8px;
  height: 30px;
}

/* ÁREA IMPRIMÍVEL */
.print-area {
  background: white;
  margin: 0 auto;
  padding: 20px;
  max-width: 900px;
  color: #222;
}

/* Cabeçalho interno do relatório */
.relatorio-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
.header-logo {
  height: 60px;
}

/* Título dentro da área imprimível */
.relatorio-title {
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 20px;
}

/* Corpo específico do relatório */
.relatorio-body {
  margin-top: 10px;
}
.relatorio-body h1,
.relatorio-body h2,
.relatorio-body h3,
.relatorio-body h4,
.relatorio-body h5,
.relatorio-body h6 {
  font-size: 14px;
  margin-top: 20px;
  margin-bottom: 5px;
}

/* Rodapé do relatório (texto fixo “Impresso em ...”) */
.relatorio-footer {
  margin-top: 10px;
  text-align: right;
  font-size: 12px;
  font-style: italic;
}

/* Não imprimir estes elementos */
@media print {
  .report-unavailable .print-area { display: none !important; }
  .nao-imprimir {
    display: none !important;
  }
}
</style>
